import Cookies from 'js-cookie';
import axios from '../lib/axios';

import { NEW_IDP_ENDPOINT, HEART_BEAT_SCRIPT_URL } from '../config';
import { startHeartBeat, stopHeartBeat } from '../lib/heartBeat';

export const HEART_BEAT_STARTED = 'HEART_BEAT_STARTED';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export function login(credentials) {
    return async dispatch => {
        dispatch({ type: LOGIN_START });
        // TODO: move cookie-setting and redirecting to the server
        try {
            const params = new URLSearchParams();
            params.append('username', credentials.email);
            params.append('password', credentials.password);

            const config = {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            const data = await axios.post(`${NEW_IDP_ENDPOINT}/v4/login/`, params, config);

            // When in local environment, we have to manually set the IDP cookie with local domain
            if (window.location.hostname === 'localhost') {
                Cookies.set('token_test', data.data.token);
            }
        } catch (error) {
            const response = error.response;
            dispatch({
                type: LOGIN_ERROR,
                error: true,
                payload: {
                    errorMessage:
                        response && response.data.displayMessage
                            ? response.data.displayMessage
                            : response.data.message
                            ? response.data.message
                            : "Errore di sistema, contattare l'assistenza.",
                    errorStatus: response.status
                }
            });
            return;
        }

        dispatch({ type: LOGIN_SUCCESS });

        dispatch(resumeLogin(true));
    };
}

export function logout() {
    return async () => {
        try {
            stopHeartBeat();
            window.location = '';
        } catch (e) {
            console.log(e);
        }
    };
}

export const HEART_BEAT_LOGOUT = 'HEART_BEAT_LOGOUT';
export function heartBeatLogout() {
    return async dispatch => {
        dispatch({ type: HEART_BEAT_LOGOUT });
    };
}

export const RESUME_LOGIN_START = 'RESUME_LOGIN_START';
export const RESUME_LOGIN_SUCCESS = 'RESUME_LOGIN_SUCCESS';
export const RESUME_LOGIN_ERROR = 'RESUME_LOGIN_ERROR';

export function resumeLogin(traceLogin = false) {
    return async dispatch => {
        dispatch({ type: RESUME_LOGIN_START });
        try {
            const { data } = await axios.get('/users/profile');
            if (HEART_BEAT_SCRIPT_URL) {
                startHeartBeat(dispatch);
            }

            dispatch({
                type: RESUME_LOGIN_SUCCESS,
                payload: { ...data, traceLogin }
            });
        } catch (err) {
            dispatch({ type: RESUME_LOGIN_ERROR });
        }
    };
}

export const IDP_LOGIN = 'IDP_LOGIN';

export function idpLogin() {
    return {
        type: IDP_LOGIN,
        isIdpLogin: true
    };
}
